// extracted by mini-css-extract-plugin
export default {"container":"PagePlaceholder__container___tgQwK","content":"PagePlaceholder__content___Qa4JF"};